// services/registerUser.js
import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

const addToWhishlistUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.addToWishlist}`;
const showWhishlistUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.getWishlist}`;

const addToWhishlistService = async (product_id) => {
  try {
    const response = await axios.post(
      addToWhishlistUrl, // Ensure this is the correct URL for adding to the wishlist
      product_id, // Send the product_id as an object in the body
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`, // Send the auth token in headers
        },
      }
    );
    return response.data; // Return the response data for further handling
  } catch (error) {
    console.error("Error adding product to wishlist:", error);
    throw error; // Throw the error for rejection in the async thunk
  }
};

const getWhishlistService = async () => {
  try {
    const response = await axios.get(showWhishlistUrl, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data; // Return the cart data
  } catch (error) {
    console.error("Error fetching cart:", error);
    throw error; // Throw the error for rejection in the async thunk
  }
};

export { addToWhishlistService, getWhishlistService };
